import Icon from "../../components/Icon"
import { formatMoney } from "../../utils/format"
import { getBillStatusMeta } from "./utbillsHelpers"
import { getUtilityInvoiceSettlement } from "./utilitySettlement"

function UtilityInvoiceStatusBadge({ invoice, compact = false, showAmounts = true }) {
  const meta = getBillStatusMeta(invoice)
  const settlement = getUtilityInvoiceSettlement(invoice)
  const settlementDetails = [
    settlement.cashPaidAmount > 0 ? `Paid ${formatMoney(settlement.cashPaidAmount)}` : "",
    settlement.creditAppliedAmount > 0 ? `From credit ${formatMoney(settlement.creditAppliedAmount)}` : "",
    settlement.waivedAmount > 0 ? `Waived ${formatMoney(settlement.waivedAmount)}` : "",
    // Extra cash on this bill that became credit with the billing company.
    settlement.creditMovedAmount > 0 ? `Kept as credit ${formatMoney(settlement.creditMovedAmount)}` : "",
  ].filter(Boolean).join(" · ")
  return (
    <span className="inline-flex flex-col items-start gap-0.5">
      {showAmounts && settlementDetails && (
        <span className={compact ? "text-[9px] text-slate-500" : "text-[10px] text-slate-500"}>
          {settlementDetails}
        </span>
      )}
      <span className="inline-flex flex-wrap items-center gap-1">
        <span className={`inline-flex items-center gap-1 rounded-md border font-semibold ${compact ? "px-1 py-0.5 text-[9px]" : "px-1.5 py-0.5 text-[10px]"} ${meta.className}`}>
          <Icon name={meta.icon} size={compact ? "0.55rem" : "0.65rem"} />
          {meta.label}
        </span>
        {meta.isOverdue && (
          <span className={`rounded-md border border-rose-200 bg-rose-50 font-semibold text-rose-700 ${compact ? "px-1 py-0.5 text-[9px]" : "px-1.5 py-0.5 text-[10px]"}`}>
            Overdue
          </span>
        )}
        {/* The customer disputes the amount; nothing pays it until it is entered again. */}
        {invoice?.objection?.status === "open" && (
          <span className={`inline-flex items-center gap-1 rounded-md border border-rose-300 bg-white font-bold text-rose-700 ${compact ? "px-1 py-0.5 text-[9px]" : "px-1.5 py-0.5 text-[10px]"}`}>
            <Icon name="flag-fill" size={compact ? "0.5rem" : "0.6rem"} />
            Objected
          </span>
        )}
      </span>
    </span>
  )
}

export default UtilityInvoiceStatusBadge
